import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';
import { DeserializeOptions } from '@lumapps/wrex/serialization/markdown/fromMarkdown/types';

import type { TableCellElement } from '../../types';
import { createTable } from '../../utils/createTable';
import { createTD } from '../../utils/createTD';
import { createTH } from '../../utils/createTH';
import { createTR } from '../../utils/createTR';

export const TABLE_ELEMENTS: DeserializeOptions['elements'] = {
    table: {
        convert(_, children) {
            // The first row of a markdown (GFM) table is always a header row of column headers.
            const firstRow = children[0];
            if (firstRow?.children) {
                firstRow.children = firstRow.children.map((cell: TableCellElement) => createTH(cell.children, 'col'));
            }
            return createTable({ readOnly: true }, children);
        },
    },
    tableRow: {
        convert: (_, children) => createTR(children),
    },
    tableCell: {
        convert: (_, children) => {
            if (!children.length) {
                // Children can't be empty.
                children.push({ text: '' });
            }
            return createTD([createParagraph(children)]);
        },
    },
};
